
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { AuthService } from "@/services";
import { BrowseService } from "@/services/browse-service";
import { ViewService } from "@/services/view-service";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			toggleViews: false,
			allViews: [] as View[],
			browses: [] as Browse[],
		};
	},
	props: {
		userId: {
			type: Number,
			required: true
		},
		selectedViews: {
			type: Array as ()=>View[],
			required: true
		},
		dossierId: {
			type: Number
		},
		overwriteExistingViews: Boolean
	},
	watch: {
		userId: {
			immediate: true,
			async handler(){
				await this.onDossierOrUserChange();
			}
		},
		dossierId: {
			async handler(){
				await this.onDossierOrUserChange();
			}
		}
	},
	methods: {
		async onDossierOrUserChange(){
			if (this.userId == 0) return;
			this.selectedViews.splice(0, this.selectedViews.length);
			await this.fetchViews();
		},
		toggleAllViews(){
			console.log("toggle");
			this.browses.map((b) => this.toggleBrowse(b,this.toggleViews));
		},
		async fetchViews(){
			if (this.dossierId == undefined || this.dossierId == 0 || this.dossierId == AuthService.wfDossier.id){
				this.allViews = await ViewService.getUsersViews(this.userId);
			}else{
				this.allViews = await ViewService.getUsersViewsFromDossier(this.dossierId, this.userId);
			}
			for (let browse of this.browses){
				browse.Views = this.allViews.filter(v=>v.BrowseID == browse.ID);
			}
		},
		isBrowseSelected(browse:Browse):boolean {
			for (let view of browse.Views){
				if (this.selectedViews.indexOf(view)==-1){
					return false;
				}
			}
			return true;
		},
		toggleBrowse(browse:Browse, value:boolean){
			if (!value){
				for (let view of browse.Views){
					this.deselectView(view);
				}
			}else{
				for (let view of browse.Views){
					this.selectView(view);
				}
			}
		},
		isViewSelected(view:View):boolean{
			let i = this.selectedViews.indexOf(view);
			return i != -1;
		},
		toggleView(view:View, value:boolean){
			if (value){
				this.selectView(view);
			}else {
				this.deselectView(view);
			}
		},
		selectView(view:View){
			if (this.isViewSelected(view)){
				return;
			}
			this.selectedViews.push(view);
		},
		deselectView(view:View){
			if (!this.isViewSelected(view)){
				return;
			}
			let i = this.selectedViews.indexOf(view);
			if (i == -1){
				return;
			}
			this.selectedViews.splice(i, 1);
		},
	},
	async created(){
		this.browses = await BrowseService.fetchBrowses();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
